import React from "react";
import { useIntl } from "umi";
import EllipsisHover from "@gp/components/EllipsisHover";
import BasicImage from "@home/components/BasicImage";
import DS1 from '@/pages/aigc/assets/ds-image1.png';

interface ChartDSTempImgProps<S = string> {
  title: S;
  img: S;
  className?: S;
}

export const ChartDSTempImg: React.FC<ChartDSTempImgProps> = ({
  title,
  img,
  className
}) => {
  const { formatMessage } = useIntl();
  if (!title) return null;
  return (
    <div className={className}> 
      <div className="dba-chat-content-template-container">
        <div className="dba-chat-content-template-container-header">
          <div className="dba-chat-content-template-container-tag">
            {formatMessage({ id: 'dba_use_template' })}
          </div>
          <div className="dba-chat-content-template-container-text">
            <EllipsisHover
              text={title}
            />
          </div>
        </div>
        <div className="dba-chat-content-template-container-img">
          <BasicImage src={img || DS1} errorSrc={DS1} />
        </div>
      </div>
    </div>
  );
};